import React, { FC, useState, useCallback } from 'react';

import { RSClampedText, RSClampedTextProps } from './components/RSClampedText';

export interface RSShowMoreTextProps {
  text: string;
  maxLine: number;
  renderShowMoreButton: (params: { onClick: () => void }) => JSX.Element | null;
}

export const RSShowMoreText: FC<RSShowMoreTextProps> = ({
  text,
  maxLine,
  renderShowMoreButton,
}) => {
  const [isClamped, setIsClamped] = useState<boolean | undefined>(undefined);
  const onClampedTextIsClampedChange = useCallback<
    RSClampedTextProps['onIsClampedChange']
  >((isClamped) => {
    setIsClamped(isClamped);
  }, []);

  const [isClampIfNeeded, setISClampIfNeeded] = useState<boolean>(true);
  const onButtonClick = useCallback(() => {
    setISClampIfNeeded((isClampIfNeeded) => !isClampIfNeeded);
  }, []);

  return (
    <>
      <RSClampedText
        text={text}
        maxLine={maxLine}
        isClampIfNeeded={isClampIfNeeded}
        onIsClampedChange={onClampedTextIsClampedChange}
      />
      {isClampIfNeeded &&
        isClamped &&
        renderShowMoreButton({ onClick: onButtonClick })}
    </>
  );
};
